<div
  *ngIf="!_env.production"
  id="dev-menu__wrapper"
  [@slideToggle]="showDevMenu ? 'visible' : 'hidden'"
>
  <div id="dev-menu">
    <header class="dev-menu__header">
      <typography-legacy class="dev-menu__title" text-medium-semibold>Dev Menu</typography-legacy>
      <button type="button" class="dev-menu__close" (click)="toggleDevMenu()">
        {{ showDevMenu ? 'Hide' : 'Show' }}
      </button>
    </header>

    <nav class="dev-menu__tabs" aria-label="Dev menu sections">
      <button
        *ngFor="let tab of devMenuTabs"
        type="button"
        class="dev-menu__btn dev-menu__btn--sm dev-menu__tab-btn"
        [class.dev-menu__btn--active]="activeTab() === tab.id"
        (click)="setActiveTab(tab.id)"
      >
        {{ tab.label }}
      </button>
    </nav>

    @if (activeTab() === 'dashboard') {
      <div class="dev-menu__tab-panel">
        <section class="dev-menu__section">
          <typography-legacy class="dev-menu__section-title" text-small-semibold>Card state (Spending)</typography-legacy>
          <p class="dev-menu__hint">Override card state for dashboard. Off = use API data.</p>
          <div class="dev-menu__card-states">
            <button
              *ngFor="let option of cardStateOptions"
              type="button"
              class="dev-menu__btn dev-menu__btn--sm"
              [class.dev-menu__btn--active]="isCardStateActive(option.value)"
              (click)="setCardState(option.value)"
            >
              {{ option.label }}
            </button>
          </div>
        </section>

        <section class="dev-menu__section">
          <typography-legacy class="dev-menu__section-title" text-small-semibold>Dashboard transactions</typography-legacy>
          <p class="dev-menu__hint">
            Savings &amp; Spending — recent transactions panel. Off = API. List rows include status badge colors.
          </p>
          <div class="dev-menu__card-states">
            <button
              *ngFor="let option of dashboardTxOptions"
              type="button"
              class="dev-menu__btn dev-menu__btn--sm"
              [class.dev-menu__btn--active]="isDashboardTxActive(option.value)"
              (click)="setDashboardTxOverride(option.value)"
            >
              {{ option.label }}
            </button>
          </div>
        </section>
      </div>
    }

    @if (activeTab() === 'flags') {
      <div class="dev-menu__tab-panel">
        <section class="dev-menu__section">
          <typography-legacy class="dev-menu__section-title" text-small-semibold>LaunchDarkly flags</typography-legacy>
          <p class="dev-menu__hint">LD = value from server. Toggle to override for this session.</p>
          <div class="dev-menu__flags" *ngIf="flagsForDisplay$ | async as flags">
            <div class="dev-menu__row dev-menu__row--flag" *ngFor="let row of flags">
              <span class="dev-menu__flag-key" [title]="row.key">{{ row.key }}</span>
              <span class="dev-menu__flag-ld" [class.dev-menu__flag-ld--on]="row.ldValue === true" [class.dev-menu__flag-ld--off]="row.ldValue === false">
                {{ row.ldValue === true ? 'LD on' : row.ldValue === false ? 'LD off' : '—' }}
              </span>
              <span class="dev-menu__flag-btns">
                <button
                  type="button"
                  class="dev-menu__btn dev-menu__btn--sm"
                  [class.dev-menu__btn--active]="row.override === true"
                  (click)="setFlagOverride(row, true)"
                >
                  On
                </button>
                <button
                  type="button"
                  class="dev-menu__btn dev-menu__btn--sm"
                  [class.dev-menu__btn--active]="row.override === false"
                  (click)="setFlagOverride(row, false)"
                >
                  Off
                </button>
                <button
                  type="button"
                  class="dev-menu__btn dev-menu__btn--sm dev-menu__btn--secondary"
                  [class.dev-menu__btn--active]="row.override === null"
                  (click)="clearFlagOverride(row)"
                >
                  Reset
                </button>
              </span>
            </div>
          </div>
          <p class="dev-menu__hint" *ngIf="(flagsForDisplay$ | async)?.length === 0">Log in to load flags.</p>
        </section>
      </div>
    }

    @if (activeTab() === 'mocks') {
      <div class="dev-menu__tab-panel">
        <section class="dev-menu__section">
          <typography-legacy class="dev-menu__section-title" text-small-semibold>Transfer funds</typography-legacy>
          <p class="dev-menu__hint">
            Appends fake external accounts to the transfer account list (no Plaid). Reloads transfer data when added or cleared.
            Use <strong>Add mock external (needs relink)</strong>, then <strong>Open Transfer Funds</strong> and pick that account
            in the from/to picker to open the relink confirmation modal.
          </p>
          <div class="dev-menu__actions">
            <button type="button" class="dev-menu__btn" (click)="addMockExternalTransferAccount()">
              Add mock external account
            </button>
            <button type="button" class="dev-menu__btn" (click)="addMockExternalTransferAccountNeedsRelink()">
              Add mock external (needs relink)
            </button>
            <button type="button" class="dev-menu__btn" (click)="clearMockExternalTransferAccounts()">
              Clear mock external accounts
            </button>
            <button type="button" class="dev-menu__btn" (click)="openTransferFunds()">
              Open Transfer Funds
            </button>
          </div>
        </section>

        <section class="dev-menu__section">
          <typography-legacy class="dev-menu__section-title" text-small-semibold>API &amp; mocks</typography-legacy>
          <div class="dev-menu__actions">
            <button
              type="button"
              class="dev-menu__btn"
              [class.dev-menu__btn--active]="_bsApi.simulateError"
              (click)="toggleApiService()"
            >
              Toggle Services
            </button>
            <button type="button" class="dev-menu__btn" (click)="mockNotifications()">
              Mock Notifications
            </button>
            <button type="button" class="dev-menu__btn" (click)="toggleAllow666()">
              {{ allow666 ? 'Disallow 666' : 'Allow 666' }}
            </button>
            <button type="button" class="dev-menu__btn" (click)="toggleCreditScoreInitialCard()">
              Toggle Credit Action Card
            </button>
            <button
              type="button"
              class="dev-menu__btn"
              [class.dev-menu__btn--active]="_creditMockState.useCreditMock()"
              (click)="toggleCreditApiMocks()"
            >
              {{ _creditMockState.useCreditMock() ? 'Disable Credit Mocks' : 'Enable Credit Mocks' }}
            </button>
            <button type="button" class="dev-menu__btn" (click)="navigateToFinancialSnapshot()">
              Go to Financial Snapshot
            </button>
            <button
              type="button"
              class="dev-menu__btn"
              [class.dev-menu__btn--active]="_devMenuService.useBadSocureTokenOnNextAttempt()"
              (click)="toggleBadSocureToken()"
            >
              Bad Socure token (next attempt)
            </button>
            <button
              type="button"
              class="dev-menu__btn"
              [class.dev-menu__btn--active]="_devMenuService.professionCollectionInjectWhenMissing()"
              (click)="toggleProfessionCollectionInjectWhenMissing()"
            >
              Inject profession when missing
            </button>
          </div>
        </section>
      </div>
    }

    @if (activeTab() === 'prompts') {
      <div class="dev-menu__tab-panel">
        <section class="dev-menu__section">
          <typography-legacy class="dev-menu__section-title" text-small-semibold>SMS prompt</typography-legacy>
          <p class="dev-menu__hint">
            SMS dev mode: <strong>{{ _devMenuService.smsPreferencesDevMode() }}</strong>.
            Use <strong>Force prompt on home</strong>, then navigate to <code>/home</code> to test the feed dialog flow.
          </p>
          <div class="dev-menu__actions">
            <button type="button" class="dev-menu__btn" (click)="openSmsPrompt()">
              Open SMS Prompt
            </button>
            <button type="button" class="dev-menu__btn" (click)="forceSmsPromptOnHome()">
              Force prompt on home
            </button>
            <button
              type="button"
              class="dev-menu__btn"
              [class.dev-menu__btn--active]="isSmsDevModeActive('get-fail')"
              (click)="toggleSmsDevMode('get-fail')"
            >
              Simulate GET failure
            </button>
            <button
              type="button"
              class="dev-menu__btn"
              [class.dev-menu__btn--active]="isSmsDevModeActive('patch-fail')"
              (click)="toggleSmsDevMode('patch-fail')"
            >
              Simulate PATCH failure
            </button>
            <button type="button" class="dev-menu__btn dev-menu__btn--secondary" (click)="resetSmsDevMode()">
              Reset SMS dev mode
            </button>
          </div>
        </section>

        <section class="dev-menu__section">
          <typography-legacy class="dev-menu__section-title" text-small-semibold>Other prompts</typography-legacy>
          <div class="dev-menu__actions">
            <button type="button" class="dev-menu__btn" (click)="openWelcomeVideo()">
              Show Welcome Video
            </button>
          </div>
        </section>
      </div>
    }

    <section class="dev-menu__section">
      <typography-legacy class="dev-menu__section-title" text-small-semibold>
        Route guard — eligibility (MW-10702)
      </typography-legacy>
      <p class="dev-menu__hint">
        Forces eligibility data-collect to treat <code>last_four_ssn</code> as empty (<code>value: ""</code>)
        so <code>eligibilityDataCollectMatchGuard</code> — the <code>canMatch</code> guard on the
        <code>home</code>, <code>onboarding</code>, and <code>credit-setup</code> routes — redirects to
        <code>/verification/eligibility</code>.
        Clears <code>hasCheckedEligibilityDataCollect</code> when toggled.
      </p>
      <div class="dev-menu__actions">
        <button
          type="button"
          class="dev-menu__btn"
          [class.dev-menu__btn--active]="_devMenuService.eligibilityLast4Inject()"
          (click)="toggleEligibilityLast4Inject()"
        >
          {{
            _devMenuService.eligibilityLast4Inject()
              ? 'Disable eligibility last 4 SSN inject'
              : 'Inject eligibility last 4 SSN (dev)'
          }}
        </button>
      </div>
      <p class="dev-menu__hint">
        To test without SSO: enable the toggle, sign in (password is fine), then load
        <code>/home</code> or
        <code>/onboarding</code> → expect redirect to <code>/verification/eligibility</code> with the last-4 form →
        <code>POST /client/confirmation</code>. Settings persist in localStorage (safe to enable before sign-in).
        <strong>Hard-reload to re-run the guard</strong> — re-navigating to a URL you are already on does
        nothing, because <code>onSameUrlNavigation</code> defaults to <code>'ignore'</code>.
      </p>
    </section>

    <ng-template #welcomeVideoContent>
      <bw-video-legacy
        [title]="'WELCOME_VIDEO_TITLE' | translate"
        [showTitle]="false"
        [cdnBase]="_env.cdnUrl"
        [path]="'videos/explainer/' + _languageSelector.activeLang + '/explainer.mp4'"
      ></bw-video-legacy>
    </ng-template>
  </div>
  <div class="dev-menu__tab" (click)="toggleDevMenu()">
    <typography-legacy text-xsmall-semibold>{{ showDevMenu ? '▲ Hide Dev Menu' : '▼ Show Dev Menu' }}</typography-legacy>
  </div>
</div>
